<div class="notifications-page">
  <div class="side-bar-notifications-menu">
    <h2>Notifications</h2>
    <ul>
      @for (filter of statusFilters; track filter) {
      <li>
        <button
          type="button"
          class="filter-button"
          [ngClass]="{ active: activeTab === filter.tab }"
          [attr.aria-label]="filter.ariaLabel"
          [attr.aria-pressed]="activeTab === filter.tab"
          (click)="setActiveTab(filter.tab)">
          {{ filter.label }}
        </button>
      </li>
      }
    </ul>
    <ul>
      @for (filter of typeFilters; track filter) {
      <li>
        <button
          type="button"
          class="filter-button"
          [ngClass]="{ active: activeTab === filter.tab }"
          [attr.aria-label]="filter.ariaLabel"
          [attr.aria-pressed]="activeTab === filter.tab"
          (click)="setActiveTab(filter.tab)">
          {{ filter.label }}
        </button>
      </li>
      }
    </ul>
  </div>
  <div class="notifications-view-area">
    <div class="notifications-view-header">
      <p class="empty-text"></p>
      <button type="button" [disabled]="markAllLoading" [attr.aria-busy]="markAllLoading" (click)="readAllClick()">
        {{ markAllLoading ? 'Updating...' : 'Mark all as read' }}
      </button>
    </div>
    <div class="notifications-list-group">
      <div class="notifications-date-group">
        <app-notifications-list [activeTab]="activeTab" [showTabs]="false" [scrollable]="false" variant="page">
        </app-notifications-list>
      </div>
    </div>
  </div>
</div>
